import { useEffect, useState } from "react";

const useCountdownTimer = (initialTimeInSeconds) => {
  const [time, setTime] = useState(initialTimeInSeconds);
  const [isActive, setIsActive] = useState(true);
  const [startTime, setStartTime] = useState(Date.now());

  useEffect(() => {
    let interval;

    if (isActive && time > 0) {
      interval = setInterval(() => {
        const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
        setTime((prevTime) => Math.max(0, initialTimeInSeconds - elapsedTime));
      }, 1000);
    } else if (time === 0) {
      clearInterval(interval);
      setIsActive(false);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isActive, time, startTime, initialTimeInSeconds]);

  const start = () => {
    setStartTime(Date.now());
    setIsActive(true);
  };

  const reset = () => {
    setIsActive(false);
    setTime(initialTimeInSeconds);
    setStartTime(Date.now());
  };

  return {
    time,
    isActive,
    start,
    reset,
  };
};

export default useCountdownTimer;
